// ─────────────────────────────────────────────────────────────────────────────
// Team Settings sub-navigation (Apr 2026)
//
// Single source of truth for the 12 settings sub-pages so all four layouts
// (Desktop / Tablet / Mobile / Capacitor) render the same expandable sub-nav
// under "Team Settings". Sub-page IDs match VALID_SECTIONS in TeamPage.jsx —
// keep these in sync when adding/removing sub-pages.
//
// Labels here are the user-facing names (chip labels in the previous in-page
// nav). The shorter ones (e.g. "Account" vs "Danger Zone") are the deliberate
// coach-friendly versions; the section IDs stay short for URL stability.
// ─────────────────────────────────────────────────────────────────────────────

export const TEAM_SETTINGS_SUBSECTIONS = [
  { id: 'team-info', label: 'Team Info' },
  { id: 'games',     label: 'Games' },
  { id: 'scoreboard',label: 'Scoreboard' },
  { id: 'reminders', label: 'Reminders' },
  // Apr 30 2026 — 'spares' (Spare Reminders) was its own sub-page
  // until coaches reported it duplicated functionality with the
  // Waitlist Management page (auto-invite spares + cascading
  // invites all triggered the same backend code paths). The two
  // sub-pages are now consolidated into "Spare and Waitlist
  // Management" at /settings/waitlist. The /settings/spares route
  // is kept as a redirect for back-compat (TeamPage routes both
  // section IDs to the same section content).
  { id: 'waitlist',  label: 'Spare and Waitlist Management' },
  { id: 'pricing',   label: 'Pricing' },
  // 2026-07-11 (batch-B G2) — renamed from "Payouts" to "Stripe" per coach
  // feedback (the section IS the Stripe Connect account panel; "Payouts"
  // undersold what it actually does — onboarding, charge status, etc.).
  // Already sits directly below 'pricing' in this array, which is the
  // single source of truth all four layouts render from — no reordering
  // needed. The section id ('payouts') and route (/settings/payouts) are
  // UNCHANGED so existing links/bookmarks keep working; only the label
  // changed.
  { id: 'payouts',   label: '🏦 Stripe' },
  { id: 'balancing', label: 'Create Teams' },
  { id: 'drinks',    label: 'Drinks' },
  { id: 'chat',      label: 'Chat & Notifications' },
  { id: 'privacy',   label: 'Privacy' },
  { id: 'danger',    label: 'Account' },
];

// Returns true when a URL pathname is on any settings sub-page (used by
// layouts to auto-expand "Team Settings" in the sidebar).
export function isSettingsRoute(pathname) {
  return /^\/team\/[^/]+\/settings(?:\/|$)/.test(pathname || '');
}

// Returns the active sub-page id from a settings URL, or null if the URL
// isn't a settings route. Used to highlight the right child in the sidebar
// without re-parsing in each layout.
export function getActiveSubsection(pathname) {
  const m = (pathname || '').match(/^\/team\/[^/]+\/settings\/([^/?#]+)/);
  return m ? m[1] : null;
}
